<template>
    <div class="richTextContainer"
         v-loading="loading">
        <template v-if="!loading">
            <div class="title">{{db.noticeTitle || db.title}}</div>
            <div class="time"
                 v-if="db.updateTime">{{db.updateTime}}</div>
            <div class="ql-editor"
                 v-if="db.noticeContent || db.content">
                <div v-if="db.noticeContent"
                     v-html="db.noticeContent"></div>
                <div v-if="db.content"
                     v-html="db.content"></div>
            </div>
            <div v-else
                 class="empty">暂无内容</div>
        </template>
    </div>
</template>

<script>
import hxlHeader from "@/views/common/header.vue";
import hxlFooder from "@/views/common/fooder.vue";
export default {
    components: {
        hxlHeader,
        hxlFooder,
    },
    data () {
        return {
            db: {},
            loading: false,
        }
    },
    mounted () {
        this.getRichText()
    },
    methods: {
        getRichText () {
            const id = this.$utils.getUrlParam('id');
            const type = this.$utils.getUrlParam('type');

            let url = type == 'help' ? '/stage-api/pre/center/' : '/stage-api/cms/pre_notice/notice_list/';
            this.loading = true
            this.$http.get(url + id).then(res => {
                this.db = (res && res.data) || {}
            }).catch(err => {
                console.error('详情加载失败', err)
                this.db = {}
            }).finally(() => {
                this.loading = false
            })
        }
    }
}
</script>

<style lang="scss">
@import './quill.snow.css';
// @import "./quill.bubble.css";
// @import "./quill.core.css";
.richTextContainer {
    width: 100%;
    max-width: 1200px;
    box-sizing: border-box;
    padding: 0 15px;
    margin: 30px auto;
    .title {
        font-size: 30px;
        font-weight: bold;
    }
    .time {
        color: rgba(0, 0, 0, 0.6);
        margin: 20px 0;
        border-bottom: 1px solid;
        padding-bottom: 20px;
    }
    .empty {
        text-align: center;
        color: rgba(0, 0, 0, 0.4);
        padding: 40px 0;
    }
}
</style>